import { render, staticRenderFns } from "./BrowseResourceMetadata.vue?vue&type=template&id=5939ea02&scoped=true"
import script from "./BrowseResourceMetadata.vue?vue&type=script&lang=js"
export * from "./BrowseResourceMetadata.vue?vue&type=script&lang=js"
import style0 from "./BrowseResourceMetadata.vue?vue&type=style&index=0&id=5939ea02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939ea02",
  null
  
)

export default component.exports